module.exports = __webpack_public_path__ + "static/media/moetez-zwari.e60900e5.png";